import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_PROVIDER_DEMO_IEAM_4 = {
  title: "User review and onboarding",
  subtitle: "Use case Provider demo",
  text: "Lastly, the user reviews and onboards \nthe application.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_109"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_107"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_01_BG.png",
  rightSideImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_04.png",
};
